import { AUTH_MODE, keycloakAuthService } from '@/auth/keycloak'
import React from 'react'
import { Outlet } from 'react-router-dom'

export const KeyCloakAuthGuarded: React.FC = () => {
  if (AUTH_MODE === 'keycloak' && !keycloakAuthService().isAuthenticated()) {
    keycloakAuthService().login()
    return null
  }

  return <Outlet />
}
